import React from 'react'
import { PropTypes } from 'prop-types'
import SanityImage from 'gatsby-plugin-sanity-image'
import { FilterIndicators } from '../Grids/Filter.styles'
import { IntegrationsCopy, IntegrationsLogo, IntegrationsSquare, LinkedIntegrationsSquare } from '../Grids/Grid.styles'

export default function IntegrationsContainer({ connector }) {
	const { tool } = connector
	const hasLink = tool.cta
	const img = tool.logo.image

	const filters = tool.categoryFilters.map((f, i) => <span key={`${i}-${f}`} className={f} />)

	return (
		<>
			{hasLink ? (
				<LinkedIntegrationsSquare key={connector._key} to={`/${tool.cta.landingPageRoute.slug.current}`}>
					<IntegrationsLogo>
						<SanityImage asset={img.asset} alt={img.alt} {...img} />
					</IntegrationsLogo>
					<IntegrationsCopy>
						<h3>{tool.title}</h3>
						<FilterIndicators>{filters}</FilterIndicators>
					</IntegrationsCopy>
				</LinkedIntegrationsSquare>
			) : (
				<IntegrationsSquare key={connector._key}>
					<IntegrationsLogo>
						<SanityImage asset={img.asset} alt={img.alt} {...img} />
					</IntegrationsLogo>
					<IntegrationsCopy>
						<h3>{tool.title}</h3>
						<FilterIndicators>{filters}</FilterIndicators>
					</IntegrationsCopy>
				</IntegrationsSquare>
			)}
		</>
	)
}

IntegrationsContainer.propTypes = {
	connector: PropTypes.object,
}
